import { Box } from '@mui/material';

import { colors } from '@/theme/variables';
import { getUpdatedLabel } from '@/utils';

interface MasterIndexUpdatedBadgeProps {
  updatedAt?: string | Date | null;
}

export const MasterIndexUpdatedBadge = ({
  updatedAt,
}: MasterIndexUpdatedBadgeProps) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.4,
        borderRadius: '6px',
        backgroundColor: colors.grey[10],
        color: colors.grey[60],
        fontSize: '0.75rem',
        lineHeight: '0.875rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      {getUpdatedLabel(updatedAt)}
    </Box>
  );
};
